// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlXA7BAk8E3NCGqFPaAd {
    position: fixed;
    inset: 0;
    background: rgba(30, 31, 35, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--curio-z-dialog);
}

.O2CRB8DD7eT1pSsOgQjs {
    background: var(--curio-card-bg);
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-lg);
    box-shadow: var(--curio-shadow-modal);
    padding: 24px;
    width: 480px;
    max-width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
    font-family: var(--curio-font-family);
    color: var(--curio-text-primary);
}

.fyP8nJdaFA1682bmQy2Q {
    margin: 0 0 4px;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--curio-text-primary);
}

.zadoS49TDKVc3HwHGt_Y {
    color: var(--curio-text-secondary);
    font-size: var(--curio-font-size-md);
    margin: 0 0 16px;
}

.UT2BUxssH0kW_YzSSrWm {
    list-style: none;
    margin: 0 0 12px;
    padding: 0;
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-md);
    overflow: hidden;
}

.bGBQpyPOY1MeNvs1nGWh {
    padding: 10px 14px;
    border-bottom: 1px solid var(--curio-border);
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
    background: var(--curio-card-bg);
}

.bGBQpyPOY1MeNvs1nGWh:last-child {
    border-bottom: none;
}

.zQ2u5evL5F5Y4LxPk5Ak {
    font-size: var(--curio-font-size-md);
    color: var(--curio-role-update-fg);
}

.MX14OW_3OgG3w9SGYXH3 {
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-md);
    padding: 12px;
    margin-bottom: 16px;
    font-size: var(--curio-font-size-md);
    background: var(--curio-page-bg);
}

.mLr9gRR7NRZNJT4BFNWs {
    margin: 0 0 6px;
    font-weight: 600;
    font-size: var(--curio-font-size-xs);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--curio-text-muted);
}

.lXArOt_P_dhiBUIJuQZU {
    display: flex;
    justify-content: space-between;
    padding: 2px 0;
    color: var(--curio-text-primary);
}

.SfIjit0edvEoObOVhwpf {
    border: 1px solid var(--curio-danger);
    border-radius: var(--curio-radius-md);
    padding: 12px;
    margin-bottom: 16px;
    font-size: var(--curio-font-size-md);
    background: rgba(255, 107, 107, 0.08);
    color: var(--curio-danger-strong);
}

.Bg9go5kbbDoDn85qDojQ {
    color: var(--curio-danger-strong);
    margin: 0 0 6px;
    font-weight: 600;
}

.r1IW3eeqM1U4o4TpWsng {
    font-size: var(--curio-font-size-md);
    margin-top: 8px;
}

.aL5LGLK0ezWkxj89in6B {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
}

.TBRnt85LpgZG4V1aT0kg {
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    border: none;
    padding: 0 20px;
    height: var(--curio-input-height);
    border-radius: var(--curio-radius-md);
    font-weight: 600;
    cursor: pointer;
    font: inherit;
    font-size: var(--curio-font-size-lg);
}

.TBRnt85LpgZG4V1aT0kg:hover:not(:disabled) {
    background: #2c2d32;
}

.TBRnt85LpgZG4V1aT0kg:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.ktE5wyCgKNZ0B_pVY1HR {
    background: var(--curio-card-bg);
    border: 1px solid var(--curio-border-strong);
    padding: 0 20px;
    height: var(--curio-input-height);
    border-radius: var(--curio-radius-md);
    font-weight: 500;
    cursor: pointer;
    font: inherit;
    font-size: var(--curio-font-size-lg);
    color: var(--curio-text-primary);
}

.ktE5wyCgKNZ0B_pVY1HR:hover:not(:disabled) {
    background: var(--curio-page-bg);
}

.ktE5wyCgKNZ0B_pVY1HR:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Striped indeterminate progress bar shown while the install POST is
 * blocked on the backend's pip step. Pip gives us no real % so the
 * stripe just slides — same pattern as the Installed-libraries modal. */
.K8Hqlb3f4POrLbgrtHts {
  margin: 10px 0 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cYwEVNxP9se8fzkLNk0I {
  width: 100%;
  height: 8px;
  background: #e0e7ff;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.Dl124sLHiFTo29QMIsAf {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35%;
  background: linear-gradient(90deg, #6366f1, #4338ca);
  border-radius: 4px;
  animation: dHewleUePPmdGaYnAaGw 1.1s ease-in-out infinite;
}
@keyframes dHewleUePPmdGaYnAaGw {
  0%   { left: -35%; }
  100% { left: 100%; }
}
.ZIEBHpHMSgAEBMV0rtrA {
  font-size: 12px;
  color: #475569;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/InstallPermissionsDialog.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,qCAAqC;IACrC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oCAAoC;IACpC,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,oDAAoD;EACpD,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(30, 31, 35, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: var(--curio-z-dialog);\n}\n\n.modal {\n    background: var(--curio-card-bg);\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-lg);\n    box-shadow: var(--curio-shadow-modal);\n    padding: 24px;\n    width: 480px;\n    max-width: 90vw;\n    max-height: 90vh;\n    overflow-y: auto;\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-primary);\n}\n\n.title {\n    margin: 0 0 4px;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.subtitle {\n    color: var(--curio-text-secondary);\n    font-size: var(--curio-font-size-md);\n    margin: 0 0 16px;\n}\n\n.permList {\n    list-style: none;\n    margin: 0 0 12px;\n    padding: 0;\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-md);\n    overflow: hidden;\n}\n\n.permItem {\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--curio-border);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n    background: var(--curio-card-bg);\n}\n\n.permItem:last-child {\n    border-bottom: none;\n}\n\n.permIcon {\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-role-update-fg);\n}\n\n.depsBox {\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-md);\n    padding: 12px;\n    margin-bottom: 16px;\n    font-size: var(--curio-font-size-md);\n    background: var(--curio-page-bg);\n}\n\n.depsTitle {\n    margin: 0 0 6px;\n    font-weight: 600;\n    font-size: var(--curio-font-size-xs);\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--curio-text-muted);\n}\n\n.depRow {\n    display: flex;\n    justify-content: space-between;\n    padding: 2px 0;\n    color: var(--curio-text-primary);\n}\n\n.conflictsBox {\n    border: 1px solid var(--curio-danger);\n    border-radius: var(--curio-radius-md);\n    padding: 12px;\n    margin-bottom: 16px;\n    font-size: var(--curio-font-size-md);\n    background: rgba(255, 107, 107, 0.08);\n    color: var(--curio-danger-strong);\n}\n\n.conflictTitle {\n    color: var(--curio-danger-strong);\n    margin: 0 0 6px;\n    font-weight: 600;\n}\n\n.conflictHint {\n    font-size: var(--curio-font-size-md);\n    margin-top: 8px;\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 16px;\n}\n\n.actionButton {\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    border: none;\n    padding: 0 20px;\n    height: var(--curio-input-height);\n    border-radius: var(--curio-radius-md);\n    font-weight: 600;\n    cursor: pointer;\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n}\n\n.actionButton:hover:not(:disabled) {\n    background: #2c2d32;\n}\n\n.actionButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.ghostButton {\n    background: var(--curio-card-bg);\n    border: 1px solid var(--curio-border-strong);\n    padding: 0 20px;\n    height: var(--curio-input-height);\n    border-radius: var(--curio-radius-md);\n    font-weight: 500;\n    cursor: pointer;\n    font: inherit;\n    font-size: var(--curio-font-size-lg);\n    color: var(--curio-text-primary);\n}\n\n.ghostButton:hover:not(:disabled) {\n    background: var(--curio-page-bg);\n}\n\n.ghostButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Striped indeterminate progress bar shown while the install POST is\n * blocked on the backend's pip step. Pip gives us no real % so the\n * stripe just slides — same pattern as the Installed-libraries modal. */\n.installProgress {\n  margin: 10px 0 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.installProgressBar {\n  width: 100%;\n  height: 8px;\n  background: #e0e7ff;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n.installProgressStripe {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 35%;\n  background: linear-gradient(90deg, #6366f1, #4338ca);\n  border-radius: 4px;\n  animation: installProgressSlide 1.1s ease-in-out infinite;\n}\n@keyframes installProgressSlide {\n  0%   { left: -35%; }\n  100% { left: 100%; }\n}\n.installProgressHint {\n  font-size: 12px;\n  color: #475569;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `AlXA7BAk8E3NCGqFPaAd`,
	"modal": `O2CRB8DD7eT1pSsOgQjs`,
	"title": `fyP8nJdaFA1682bmQy2Q`,
	"subtitle": `zadoS49TDKVc3HwHGt_Y`,
	"permList": `UT2BUxssH0kW_YzSSrWm`,
	"permItem": `bGBQpyPOY1MeNvs1nGWh`,
	"permIcon": `zQ2u5evL5F5Y4LxPk5Ak`,
	"depsBox": `MX14OW_3OgG3w9SGYXH3`,
	"depsTitle": `mLr9gRR7NRZNJT4BFNWs`,
	"depRow": `lXArOt_P_dhiBUIJuQZU`,
	"conflictsBox": `SfIjit0edvEoObOVhwpf`,
	"conflictTitle": `Bg9go5kbbDoDn85qDojQ`,
	"conflictHint": `r1IW3eeqM1U4o4TpWsng`,
	"footer": `aL5LGLK0ezWkxj89in6B`,
	"actionButton": `TBRnt85LpgZG4V1aT0kg`,
	"ghostButton": `ktE5wyCgKNZ0B_pVY1HR`,
	"installProgress": `K8Hqlb3f4POrLbgrtHts`,
	"installProgressBar": `cYwEVNxP9se8fzkLNk0I`,
	"installProgressStripe": `Dl124sLHiFTo29QMIsAf`,
	"installProgressSlide": `dHewleUePPmdGaYnAaGw`,
	"installProgressHint": `ZIEBHpHMSgAEBMV0rtrA`
};
export default ___CSS_LOADER_EXPORT___;
